module.exports = __webpack_public_path__ + "static/media/OppdragAgreementEdits.eda28b73.jpg";